import { useEffect, useRef, useState } from "react";
import { BACKEND_AI_AGENT_URL } from "../../../../config";

interface FearAndGreedIndex {
  update_time: string;
  value: number;
  value_classification: string;
}

const MarketSentiment = () => {
  const [value, setValue] = useState<FearAndGreedIndex>({
    update_time: "",
    value: 0,
    value_classification: "",
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTrendingData = async () => {
      try {
        const response = await fetch(
          `${BACKEND_AI_AGENT_URL}/fear-and-greed-index`,
        );

        if (!response.ok) {
          console.error("Failed to fetch fear and greed index");
          return;
        }

        const data: FearAndGreedIndex = await response.json();
        setValue(data);
      } catch (error) {
        console.error("Failed to fetch trending narratives:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTrendingData();
  }, []);

  const pathRef = useRef<SVGPathElement | null>(null);

  const mapValueToPath = (): { x: number; y: number } => {
    if (pathRef.current) {
      const pathLength = pathRef.current.getTotalLength();
      const pointAtLength = pathRef.current.getPointAtLength(
        Math.max(0, Math.min(100, value.value) / 100) * pathLength,
      );
      return { x: pointAtLength.x, y: pointAtLength.y };
    }
    return { x: 0, y: 0 };
  };

  const { x, y } = mapValueToPath();
  console.log("xm,ym", x, y, value.value);

  return (
    <div className="relative">
      <div
        className="justify-center items-center absolute flex flex-col gap-1"
        style={{ top: "60%", left: "50%", transform: "translate(-50%, -50%)" }}
      >
        <div className="text-2xl font-bold">{value.value}</div>
        <div className="text-sm">{value.value_classification}</div>
      </div>
      <svg
        className="ellipse-svg overflow-visible"
        viewBox="0 0 142 74"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="139.5"
            y1="77.5"
            x2="-1.5"
            y2="77.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4CAF50" />
            <stop offset="0.5" stopColor="#FFCA28" />
            <stop offset="1" stopColor="#C62828" />
          </linearGradient>
        </defs>

        <path
          ref={pathRef}
          d="M 1 73 A 70 70 0 0 1 141 73"
          fill="none"
          stroke="url(#paint0_linear)"
          stroke-width="5"
          stroke-linecap="round"
        />

        {!isLoading && <circle cx={x} cy={y} r="6" fill="#007DFF" />}
      </svg>
    </div>
  );
};

export default MarketSentiment;
